import { render } from "./ForgotUsernameView.vue?vue&type=template&id=398e6f17&ts=true"
import script from "./ForgotUsernameView.vue?vue&type=script&lang=ts"
export * from "./ForgotUsernameView.vue?vue&type=script&lang=ts"

import "./ForgotUsernameView.vue?vue&type=style&index=0&id=398e6f17&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__